import api from "../axios_service";

export async function listaDeContasPagar(filtros) {
  const response = await api.get(
    `/relatorios/contaspagar${filtros ? filtros : ""}`
  );
  return response.data.result;
}